module.exports = __webpack_public_path__ + "img/schmiedekunst.477b77d7.jpg";